<template>
    <b-col class="mobile-header-section">
        <div class="back-link-wrapper-mobile">
            <a v-if="backToLink" class="back-link" :href="backToLink"><ArrowLeft />Back</a>

            <div v-if="$route.name === $routes.TALENT_ONBOARDING.name" class="ml-auto d-flex align-items-center">
                <router-link :to="{ name: $routes.TALENT_LOGIN.name }">Already Have An Account?</router-link>
            </div>
        </div>

        <div class="header-section">
            <h2 class="header">{{ header }}</h2>
            <p class="subheader">{{ subheader }}</p>
        </div>
    </b-col>
</template>

<script>
import ArrowLeft from '@/components/Icon/ArrowLeft.vue';

export default {
    name: 'MobileOnboardingHeader',
    components: {
        ArrowLeft,
    },
    props: {
        backToLink: {
            type: String,
            required: false,
            default: '',
        },
        header: {
            type: String,
            required: true,
        },
        subheader: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.mobile-header-section {
    padding: 0;
    color: var(--WHITE, #fff);
    background-color: var(--Colors-Primary-Grayscale-Black, #121212);
    background-image: url('../../../../public/images/logo/mark-gray.svg');
    background-position: top right;
    background-repeat: no-repeat;
    background-size: 170px auto;
}

.back-link-wrapper-mobile {
    min-height: 60px;
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
}

.back-link,
.back-link:hover {
    text-decoration: none;
}

.back-link {
    display: flex;
    align-items: center;
    gap: 12px;
}

@media (max-width: 768px) {
    .mobile-header-section {
        .back-link-wrapper-mobile {
            display: flex;
            padding: 10px 16px;

            a {
                color: var(--Colors-Primary-Grayscale-White, #fff);
            }

            .back-link {
                padding: 8px 12px;
            }
        }

        .header-section {
            margin: 0 17.5px 40px 17.5px;
            display: flex;
            flex-direction: column;
            gap: 20px;

            h2,
            p {
                margin: 0;
            }

            h2 {
                font-family: Inter;
                font-size: 24px;
                font-weight: 600;
                line-height: 150%; /* 36px */
            }

            p {
                font-family: Inter;
                font-size: 14px;
                font-weight: 400;
                line-height: 24px;
            }
        }
    }
}
</style>

<style>
@media (max-width: 768px) {
    .back-link-wrapper {
        display: none;
    }

    .page-content {
        position: relative;
        z-index: 2;
        border-radius: 16px 16px 0px 0px;
        margin-top: -16px;
        padding: 40px 16px;
    }
}
</style>
